if (window.AthosProductList && !customElements.get('search-favourites')) {
  class SearchFavourites extends window.AthosProductList {
    static SETTLE_TIMEOUT = 2500;

    constructor() {
      super();
      this.isReturning = SearchFavourites.hasRecentlyViewed();
      this.started = false;
      this.settled = false;
    }

    static hasRecentlyViewed() {
      try {
        const key = Object.keys(window.localStorage).find((name) => name.startsWith('recentProducts'));

        if (!key) {
          return false;
        }

        const stored = JSON.parse(window.localStorage.getItem(key));

        return Array.isArray(stored) && stored.length > 0;
      } catch (error) {
        return false;
      }
    }

    connectedCallback() {}

    disconnectedCallback() {
      clearTimeout(this.settleTimer);
      super.disconnectedCallback();
    }

    start() {
      if (this.started) {
        return;
      }

      this.started = true;

      if (this.dataset.waiting !== 'true') {
        this.settle();
        return;
      }

      this.settleTimer = setTimeout(() => this.settle(), SearchFavourites.SETTLE_TIMEOUT);

      this.whenAthosReady()
        .then((ready) => (ready ? this.run() : this.settle()))
        .catch(() => this.settle());
    }

    settle() {
      if (this.settled) {
        return;
      }

      this.settled = true;
      clearTimeout(this.settleTimer);

      this.querySelector('[data-list-target]')?.classList.remove('hidden');
      this.querySelector('[data-favourites-skeleton]')?.remove();
    }

    onEmpty() {
      this.settle();
    }

    get profileTag() {
      if (this.isReturning && this.dataset.tagReturning) {
        return this.dataset.tagReturning;
      }

      return this.dataset.tag;
    }

    get fallbackProfileTag() {
      return this.dataset.tagFallback || this.dataset.tag;
    }

    renderSlots(slots) {
      const target = this.querySelector('[data-list-target]');

      if (this.settled || (target?.children.length > 0 && slots.length < this.displayLimit)) {
        return [];
      }

      return super.renderSlots(slots);
    }

    onRendered(usedFallback) {
      const returningHeading = this.dataset.headingReturning;
      const heading = document.getElementById(this.dataset.headingId);

      if (heading && returningHeading && this.isReturning && this.dataset.tagReturning && !usedFallback) {
        heading.textContent = returningHeading;
      }

      this.settle();
    }
  }

  customElements.define('search-favourites', SearchFavourites);
}
